import {
  Breadcrumb,
  DefaultButton,
  PrimaryButton,
  Spinner,
  SpinnerSize,
  TextField,
} from "@fluentui/react";
import React, { useState, useEffect, useContext } from "react";
import CustomBreadCrumb from "../../components/CustomBreadCrumb";
import { useFormik, validateYupSchema } from "formik";
import { Link, redirect, useLocation, useNavigate } from "react-router-dom";
import { changePassword } from "../../service/UserService";
import { ChangePasswordSchema } from "../../Schemas/ChangePasswordSchema";
import { t } from "i18next";
import {
  AuthRoutes,
  NonAuthRoutes,
  TOAST_TYPE,
} from "../../constants/Constants";
import { encryptData } from "../../helpers/RSAUtility";
import loaderContext from "../../context/loader/LoaderContext";
import toastContext from "../../context/toast/ToastContext";

const ChangePassword = () => {
  const { ref, setLoaderRunning } = useContext(loaderContext);
  const { showToastv2 } = useContext(toastContext);
  const location = useLocation();
  const navigate = useNavigate();
  const [redirectedReason, setRedirectedReason] = useState("");

  const [isForceChangePassword, setIsForceChangePassword] = useState(false);
  const data = {
    oldPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  };

  useEffect(() => {
    const forceReset =
      localStorage.getItem("forceReset") === "true" ? true : false;
    const redirectOnLogin =
      localStorage.getItem("redirectOnLogin") === "true" ? true : false;

    if (forceReset) {
      if (redirectOnLogin) {
        setRedirectedReason(1);
      } else {
        setRedirectedReason(2);
      }
      setIsForceChangePassword(true);
      return;
    }
    if (redirectOnLogin) {
      setRedirectedReason(3);
      setIsForceChangePassword(true);
    }
  }, []);

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: data,
      validationSchema: ChangePasswordSchema,
      onSubmit: async (values, actions) => {
        // setLoadingState("Submitting user details");
        // setLoading(true);
        setLoaderRunning(true);
        ref.current.continuousStart();
        const body = {
          changePassword: {
            oldPassword: encryptData(values.oldPassword),
            newPassword: encryptData(values.newPassword),
            confirmNewPassword: encryptData(values.confirmNewPassword),
          },
        };
        console.log(body);
        const response = await changePassword(body);
        console.log(response);
        if (response.status === 200 && response.data.result === "SUCCESS") {
          if (isForceChangePassword) {
            localStorage.setItem("forceReset", false);
            localStorage.setItem("redirectOnLogin", false);
            setIsForceChangePassword(false)
          }
          actions.resetForm();
          setLoaderRunning(false);
          ref.current.complete();
          showToastv2(TOAST_TYPE.SUCCESS, t("change-password.password-change-successfully") );      
          setTimeout(()=>{
            if((redirectedReason === 1 || redirectedReason === "" || redirectedReason === undefined || redirectedReason === null) && process.env.REACT_APP_HYBRID_MODE == "false") {
              window.location.href = AuthRoutes.STUDYLIST;
            } else {
              window.location.href = "/"
            }
          },1000);
        } else {
          response.data.data.forEach((error) => {
            actions.setFieldError(error.fieldName, error.defaultMessage);
          });
          setLoaderRunning(false);
          ref.current.complete();
          showToastv2(TOAST_TYPE.ERROR, t("change-password.password-change-unsuccessfully"));
        }
      },
    });

  return (
    <>
      {
        <div className="tab-section">
          {/* <div className="breadCrumb">
              <CustomBreadCrumb items={changePasswordBreadCrumbItems} />
            </div> */}
          <section className="sectionA">
            <p
              style={{
                fontSize: "20px",
                fontWeight: "600",
                padding: "0px 0px",
              }}
            >
              {t("change-password.change-password")}
            </p>
          </section>
          {/* <div className="form-section-header">
          <p>Change Password</p>
        </div> */}
          <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid-row">
              <div style={{ margin: "0px 0px 10px" }}>
                {isForceChangePassword && redirectedReason === 1 && (
                  <p style={{ margin: "0" }}>
                    <span className="ms-fontWeight-bold">{t("change-password.welcome")}</span>
                    <br></br>
                    <span>
                      {t("change-password.change-password-before-start")}
                    </span>
                  </p>
                )}
                {isForceChangePassword && redirectedReason === 2 && (
                  <p style={{ margin: "0" }}>
                    <span className="ms-fontWeight-bold">
                    {t("change-password.password-expired")}
                    </span>
                    <br></br>
                    <span>
                    {t("change-password.change-password-before-continue")}
                    </span>
                  </p>
                )}
                {isForceChangePassword && redirectedReason === 3 && (
                  <p style={{ margin: "0" }}>
                    <span className="ms-fontWeight-bold">{t("change-password.welcome-back")}</span>
                    <br></br>
                    <span>
                    {t("change-password.change-password-recently-reset")}
                    </span>
                  </p>
                )}
              </div>
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl5">
                <p className="form-field-key">{t("change-password.old-password")}</p>
                <div
                  className="form-field-value"
                  style={{ marginBottom: "20px" }}
                >
                  <TextField
                    name="oldPassword"
                    placeholder={t("placeholder.enter-old-password")}
                    type="password"
                    onChange={handleChange}
                    autoComplete="off"
                    value={values.oldPassword}
                    canRevealPassword
                    onBlur={handleBlur}
                    errorMessage={touched.oldPassword && errors.oldPassword}
                  />
                </div>
              </div>
            </div>

            <div className="ms-Grid-row">
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl5">
                <p className="form-field-key">{t("change-password.new-password")}</p>
                <div
                  className="form-field-value"
                  style={{ marginBottom: "30px" }}
                >
                  <TextField
                    name="newPassword"
                    placeholder={t("placeholder.enter-new-password")}
                    type="password"
                    onChange={handleChange}
                    canRevealPassword
                    autoComplete="off"
                    value={values.newPassword}
                    onBlur={handleBlur}
                    errorMessage={touched.newPassword && errors.newPassword}
                  />
                </div>
              </div>
            </div>

            <div className="ms-Grid-row">
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl5">
                <p className="form-field-key">{t("change-password.confirm-new-password")}</p>
                <div
                  className="form-field-value"
                  style={{ marginBottom: "20px" }}
                >
                  <TextField
                    name="confirmNewPassword"
                    placeholder={t("change-password.confirm-new-password")}
                    type="password"
                    autoComplete="off"
                    canRevealPassword
                    onChange={handleChange}
                    value={values.confirmNewPassword}
                    onBlur={handleBlur}
                    errorMessage={
                      touched.confirmNewPassword && errors.confirmNewPassword
                    }
                  />
                </div>
              </div>
            </div>
            <div className="view-page-buttons">
              <PrimaryButton
                className="view-page-button"
                text={t("button.save")}
                onClick={handleSubmit}
              />
              {/* </Link> */}
              {/* <DefaultButton
                className="view-page-button"
                text="Back"
                onClick={() => navigate(-1)}
              /> */}
            </div>
            {/* {isForceChangePassword && (
              <>
                <div style={{ marginTop: "15px" }}>
                  <span
                    className="ms-fontSize-12 cursor-pointer"
                    style={{
                      textDecoration: "underline",
                    }}
                    onClick={() => {
                      localStorage.setItem("forceReset", false);
                      localStorage.setItem("redirectOnLogin", false);
                      window.location.href = "/"
                    }}
                  >
                    {t("change-password.back-to-login")}
                  </span>
                </div>
              </>
            )} */}
            {/* {!isForceChangePassword && (
              <>
                <div style={{ marginTop: "15px" }}>
                  <span
                    className="ms-fontSize-12 cursor-pointer"
                    style={{
                      textDecoration: "underline",
                      marginTop: "15px",
                    }}
                    onClick={() => {
                      window.location.href = '/';
                    }}
                  >
                    {t("change-password.back-to-studylist")}
                  </span>
                </div>
              </>
            )} */}
          </div>
        </div>
      }
    </>
  );
};

export default ChangePassword;
